import { appNotOpened, clear, setApiErrorHandler, setAuthFailureHandler, tenantInactive } from '@yc/api-client'
import ElementPlus from 'element-plus'
import { createApp } from 'vue'

import { perm } from '@yc/ui-kit'

import '@yc/ui-kit/styles'

import App from './App.vue'
import { router } from './router'
import { installGuard, resetPermCache } from './router/guard'

const app = createApp(App)

app.use(ElementPlus)
app.directive('perm', perm)

// 登录态彻底失效（refresh 失败）时整站跳登录，权限缓存一并作废
setAuthFailureHandler(() => {
  clear()
  resetPermCache()
  const current = router.currentRoute.value
  if (current.name !== 'login') {
    void router.replace({ name: 'login', query: { redirect: current.fullPath } })
  }
})

installGuard()

// 企业停用/到期（40303）与子系统未开通（40301）不是登录态问题，落到各自文案页区分说明；
// 不跳登录页——账号密码是好的，重新登录只会得到同样的结果。
//
// 必须加在途闩锁：跳转过程中 currentRoute 还是旧值，只判 currentRoute 会让每次失败都
// 再发一次 replace，把上一次导航取消掉。实测租户停用后 /me/perms 3 秒被打 1946 次。
let leavingForUnavailable = false
setApiErrorHandler((e) => {
  if (!appNotOpened(e) && !tenantInactive(e)) return
  if (leavingForUnavailable) return
  if (router.currentRoute.value.name === 'app-unavailable') return
  leavingForUnavailable = true
  void router
    .replace({ name: 'app-unavailable', query: { code: String(e.code), msg: e.message } })
    .finally(() => {
      leavingForUnavailable = false
    })
})

app.use(router)
app.mount('#app')
